import React from 'react';
import TimelineResumePersonalInformation from './TimelineResumePersonalInformation';
import TimelineResumeSummary from "./TimelineResumeSummary";
import TimelineResumeHobbies from "./TimelineResumeHobbies";
import TimelineResumeCustom from "./TimelineResumeCustom";
import TimelineResumeEmployment from './TimelineResumeEmployment';
import TimelineResumeEducation from "./TimelineResumeEducation";
import TimelineResumeReference from "./TimelineResumeReference";
import TimelineResumeSkills from "./TimelineResumeSkills";
import TimelineResumeLanguage from "./TimelineResumeLanguage";

export default class TimelineResume extends React.Component {
    getAllOtherParts(){
        let otherForms = []
        for(let i = 0; i < this.props.resumeData.otherForms.length; i++){
            let form = this.props.resumeData.otherForms[i];
            switch(form.type){
                case 'summary':
                    otherForms.push(<TimelineResumeSummary title={form.title} data={form.data} key={i}/>);
                    break;
                case 'hobbies':
                    otherForms.push(<TimelineResumeHobbies title={form.title} data={form.data} key={i}/>);
                    break;
                case 'custom':
                    otherForms.push(<TimelineResumeCustom title={form.title} data={form.data} key={i}/>);
                    break;
                case 'employment':
                    otherForms.push(<TimelineResumeEmployment title={form.title} data={form.data} key={i}/>);
                    break;
                case 'education':
                    otherForms.push(<TimelineResumeEducation title={form.title} data={form.data} key={i}/>);
                    break;
                case 'references':
                    otherForms.push(<TimelineResumeReference title={form.title} data={form.data} key={i}/>);
                    break;
                case 'skills':
                    otherForms.push(<TimelineResumeSkills title={form.title} data={form.data} key={i}/>);
                    break;
                case 'languages':
                    otherForms.push(<TimelineResumeLanguage title={form.title} data={form.data} key={i}/>);
                default:
                // Do nothing;
            }
        }
        return otherForms;
    }
    render() {
        return  <div data-v-2568b4c2="" className="container">
            <TimelineResumePersonalInformation
                title={this.props.resumeData.personalDetailForm.title}
                data={this.props.resumeData.personalDetailForm.data}/>
            {this.getAllOtherParts()}
        </div>;
    }
}